import { requestGooseAPI, getAPIPath } from '../shared/request'
import {
  CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH,
  CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH_ID,
} from '../types/constants'
import {
  APIAssociatedContactClientDtoResponse,
  AssociatedContactClientDto,
  AssociatedContactCreateInput,
  AssociatedContactUpdateInput,
} from '../types/api'

export const ClientLocationAssociatedContactService = {
  list: (locationId: string, lupId: string) => {
    return requestGooseAPI<APIAssociatedContactClientDtoResponse>({
      url: getAPIPath(CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH, { locationId, lupId }),
      method: 'GET',
    })
  },

  get: (locationId: string, lupId: string, contactId: string) => {
    return requestGooseAPI<AssociatedContactClientDto>({
      url: getAPIPath(CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH_ID, { locationId, lupId, id: contactId }),
      method: 'GET',
    })
  },

  create: (locationId: string, lupId: string, payload: AssociatedContactCreateInput) =>
    requestGooseAPI<AssociatedContactClientDto>({
      url: getAPIPath(CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH, { locationId, lupId }),
      method: 'POST',
      data: payload,
    }),

  remove: (locationId: string, lupId: string, contactId: string) =>
    requestGooseAPI<AssociatedContactClientDto>({
      url: getAPIPath(CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH_ID, { locationId, lupId, id: contactId }),
      method: 'DELETE',
    }),

  update: (locationId: string, lupId: string, contactId: string, payload: AssociatedContactUpdateInput) =>
    requestGooseAPI<AssociatedContactClientDto>({
      url: getAPIPath(CLIENT_LOCATION_ASSOCIATED_CONTACTS_PATH_ID, { locationId, lupId, id: contactId }),
      method: 'PUT',
      data: payload,
    }),
}
